//Provide a global abstraction from the implementation details of an api call

import { LicenseServerAPI } from './licenseserver-api';

export * from '../../webmodule-common/other/api/api-injector';

export interface ApiFactory {
  licenseServer: () => LicenseServerAPI;
}

let _apiFactory: ApiFactory = {
  licenseServer: () => {
    throw new Error('please call setApiInjector - supplier api not registered');
  }
};

export function setApiFactory(factory: ApiFactory) {
  _apiFactory = factory;
}

export function getApiFactory() {
  return _apiFactory;
}
